import type { ColumnType } from 'antd/es/table';
import {
    formatSearchVolume,
    formatPercent,
    formatPercentTag,
    formatAdvantage,
    formatPriceAdvantage,
    formatPrice,
    formatNumber,
    searchVolumeSorter,
} from '../formatters';

/**
 * 优势关键词 - 转化率优势列
 */
export const conversionAdvantageColumns: ColumnType<any>[] = [
    {
        title: '搜索词',
        dataIndex: 'search_query',
        key: 'search_query',
        width: 180,
    },
    {
        title: '搜索量',
        dataIndex: 'search_volume',
        key: 'search_volume',
        width: 90,
        render: formatSearchVolume,
        sorter: searchVolumeSorter,
    },
    {
        title: 'ASIN转化率',
        dataIndex: 'asin_cvr',
        key: 'asin_cvr',
        render: (val: number) => formatPercentTag(val, 'green'),
    },
    {
        title: '大盘转化率',
        dataIndex: 'market_cvr',
        key: 'market_cvr',
        render: formatPercent,
    },
    {
        title: '优势',
        dataIndex: 'advantage_percent',
        key: 'advantage_percent',
        render: formatAdvantage,
    },
];

/**
 * 优势关键词 - 点击率优势列
 */
export const ctrAdvantageColumns: ColumnType<any>[] = [
    {
        title: '搜索词',
        dataIndex: 'search_query',
        key: 'search_query',
        width: 180,
    },
    {
        title: '搜索量',
        dataIndex: 'search_volume',
        key: 'search_volume',
        width: 90,
        render: formatSearchVolume,
        sorter: searchVolumeSorter,
    },
    {
        title: 'ASIN点击率',
        dataIndex: 'asin_ctr',
        key: 'asin_ctr',
        render: (val: number) => formatPercentTag(val, 'green'),
    },
    {
        title: '大盘点击率',
        dataIndex: 'market_ctr',
        key: 'market_ctr',
        render: formatPercent,
    },
    {
        title: '优势',
        dataIndex: 'advantage_percent',
        key: 'advantage_percent',
        render: formatAdvantage,
    },
];

/**
 * 优势关键词 - 占比优势列
 */
export const shareAdvantageColumns: ColumnType<any>[] = [
    {
        title: '搜索词',
        dataIndex: 'search_query',
        key: 'search_query',
        width: 180,
    },
    {
        title: '搜索量',
        dataIndex: 'search_volume',
        key: 'search_volume',
        width: 90,
        render: formatSearchVolume,
        sorter: searchVolumeSorter,
    },
    {
        title: '点击占比',
        dataIndex: 'clicks_share',
        key: 'clicks_share',
        render: (val: number) => formatPercentTag(val, 'blue'),
    },
    {
        title: '购买占比',
        dataIndex: 'purchases_share',
        key: 'purchases_share',
        render: formatPercent,
    },
    {
        title: '曝光量',
        dataIndex: 'impressions',
        key: 'impressions',
        render: formatNumber,
    },
];

/**
 * 优势关键词 - 价格优势列
 */
export const priceAdvantageColumns: ColumnType<any>[] = [
    {
        title: '搜索词',
        dataIndex: 'search_query',
        key: 'search_query',
        width: 180,
    },
    {
        title: '搜索量',
        dataIndex: 'search_volume',
        key: 'search_volume',
        width: 90,
        render: formatSearchVolume,
        sorter: searchVolumeSorter,
    },
    {
        title: 'ASIN价格',
        dataIndex: 'asin_price',
        key: 'asin_price',
        render: formatPrice,
    },
    {
        title: '市场价格',
        dataIndex: 'market_price',
        key: 'market_price',
        render: formatPrice,
    },
    {
        title: '价格优势',
        dataIndex: 'price_advantage_percent',
        key: 'price_advantage_percent',
        render: formatPriceAdvantage,
    },
];
